import axios from 'axios';
import { getEnvVar } from 'helpers';

const toMessage = value => {
  if (!value) {
    return '';
  }
  if (typeof value === 'string') {
    return value;
  }
  if (Array.isArray(value)) {
    return value.map(toMessage).filter(Boolean).join(' | ');
  }
  if (typeof value === 'object') {
    return (
      toMessage(value.message) ||
      toMessage(value.error) ||
      toMessage(value.Error) ||
      toMessage(value.details) ||
      toMessage(value.title) ||
      (() => {
        try {
          return JSON.stringify(value);
        } catch (e) {
          return String(value);
        }
      })()
    );
  }
  return String(value);
};

export const querySurveyAiGenerator = async ({
  surveyApiRoot,
  tenantId,
  contextId,
  text,
  messageHistory,
  query,
  currentSurveyJSON,
  selectedElement,
  xToken,
  signal,
  logger = console
}) => {
  if (!tenantId || !contextId) {
    throw new Error('Missing tenant or context for AI request');
  }

  const url = `${surveyApiRoot}adm-survey/ai/tenants/${encodeURIComponent(
    tenantId
  )}/context/${encodeURIComponent(contextId)}/query`;

  try {
    const headers = {
      ...(xToken ? { 'x-token': xToken } : {})
    };

    const config = {
      ...(Object.keys(headers).length > 0 ? { headers } : {}),
      ...(signal ? { signal } : {})
    };

    const response = await axios.post(url, {
      text,
      messageHistory,
      query,
      currentSurveyJSON,
      selectedElement
    }, Object.keys(config).length > 0 ? config : undefined);

    logger.log('[AI Survey][Backend Response]', {
      status: response?.status,
      data: response?.data
    });

    return response.data;
  } catch (error) {
    if (axios.isCancel(error) || error?.name === 'AbortError' || error?.name === 'CanceledError') {
      throw error;
    }
    const status = error?.response?.status;
    const data = error?.response?.data;
    const fallbackMessage = getEnvVar('ADM_SURVEY_AI_ERROR_MESSAGE') || 'An error occurred while generating the AI response. Please try again.';
    const parsedMessage =
      toMessage(data?.Error) ||
      toMessage(data?.error) ||
      toMessage(data?.message) ||
      toMessage(data) ||
      toMessage(error?.message) ||
      fallbackMessage;

    const err = new Error(parsedMessage);
    err.status = status;
    err.response = error.response;
    throw err;
  }
};
